export default class Permissions {
    public static readonly RolesManage = 'roles.manage';
    public static readonly UserRolesManage = 'users.roles.manage';
    public static readonly LeaseRecordsAccess = 'lease_records.access';
    public static readonly LeaseRecordsVoid = 'lease_records.void';
    // Mirrors LandHawk.Business.Permissions.BackOfficePayroll - the one permission behind Check
    // Register, Employee Payroll, Commission and Director Commission.
    public static readonly BackOfficePayroll = 'back_office.payroll';
}



// WEBPACK FOOTER //
// ./src/models/Permissions.ts